<div class="screen">

  <!-- ── Contexte ── -->
  <div class="context-card" [attr.data-tension]="tensionKey()">
    <span class="context-eyebrow">{{ 'mobileSimulator.renfort.eyebrow' | translate }}</span>
    <h2 class="context-site">{{ siteName }}</h2>
    <p class="context-sub">{{ 'mobileSimulator.renfort.subtitle' | translate }}</p>
  </div>

  <!-- ── Message ── -->
  <div class="section">
    <p class="section-title">{{ 'mobileSimulator.renfort.messageLabel' | translate }}</p>
    <textarea
      class="message-input"
      [value]="message()"
      (input)="message.set($any($event.target).value)"
      rows="7"
      [placeholder]="'mobileSimulator.renfort.messagePlaceholder' | translate"></textarea>
  </div>

  <!-- ── Sites destinataires ── -->
  <div class="section">
    <div class="section-header">
      <p class="section-title">{{ 'mobileSimulator.renfort.recipientsTitle' | translate }}</p>
      <span class="section-count">{{ (selectedCount() > 1 ? 'mobileSimulator.common.selectedPlural' : 'mobileSimulator.common.selectedSingular') | translate: { count: selectedCount() } }}</span>
    </div>

    <div class="site-list">
      @for (site of sites(); track site.nom) {
        <button class="site-row" [class.site-row--selected]="site.selected" (click)="toggleSite(site.nom)">
          <div class="site-row-left">
            <span class="site-check" [class.site-check--on]="site.selected">
              @if (site.selected) {
                <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                </svg>
              }
            </span>
            <span class="site-name">{{ site.nom }}</span>
          </div>
          <span class="site-badge" [attr.data-tension]="statutKey(site.statut)">{{ statutLabel(site.statut) }}</span>
        </button>
      }
    </div>
  </div>

  <!-- ── Envoyer ── -->
  <button class="send-btn" [attr.data-tension]="tensionKey()" [disabled]="selectedCount() === 0" (click)="send()">
    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
      <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
    </svg>
    {{ 'mobileSimulator.renfort.sendButton' | translate }}
  </button>

</div>